import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

export default {
  computed: {
    mapFields() {
      return {};
    }
  },
  methods: {
    handleRelation(entityName, data) {
      if (data[entityName]) {
        const obj = data[entityName];
        Object.keys(obj).forEach((key) => {
          data[`${entityName}_${key}`] = obj[key];
          delete data[entityName];
        });
      }
    },
    keepOnlyDataWithKeywords(arr, keywords) {
      return arr.filter(obj => {
        const values = Object.values(obj).filter(value => value)
          .map(value => value.toString().toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
          );
        return values.some(value => keywords.includes(value));
      });
    },
    generateXLS(reportData, filename = 'report') {
      const worksheet = XLSX.utils.json_to_sheet(reportData);
      const workbook = {
        Sheets: {
          ["Relatório"]: worksheet,
        },
        SheetNames: ["Relatório"],
      };
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const data = new Blob([excelBuffer], { type: ".xlsx" });
      FileSaver.saveAs(
        data,
        `${filename}.xlsx`
      );
    },
    generatePDF(fields, data, filename = 'report') {
      this.$http
        .post(
          "https://us-central1-jaiminhobot.cloudfunctions.net/generatePDFReport",
          {
            fields: fields,
            data: data,
          },
          {
            responseType: "blob",
          }
        )
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${filename}.pdf`);
          link.click();
        });
    },
  }
};